"use client";
import { DollarSign, Package, Users } from "lucide-react";
import { Summary } from "../../pages/SalesPage/SalesPageInterface";
import { formatCOP } from "../../utils/formatters";
import { useCurrency } from "../../context/Currency";
import { useAuth } from "../../context/AuthContext";
import { dictionary } from "../../utils/dictionary";

const SalesStats = ({ summary }: { summary: Summary }) => {
  const { language } = useAuth();
  const { isDollar } = useCurrency();

  return (
    <div className="grid grid-cols-3 gap-4 mb-6">
      <div className="bg-white p-4 rounded-xl shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">{dictionary["total-sales"][language]}</p>
            <p className="text-2xl font-bold mt-1">
              {formatCOP(Number(summary?.total_value_with_discount || 0), isDollar)}
            </p>
          </div>
          <div className="p-3 bg-blue-50 rounded-lg">
            <DollarSign className="text-[#5050EA]" size={24} />
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-xl shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">{dictionary["products-sold"][language]}</p>
            <p className="text-2xl font-bold mt-1">
              {summary?.total_units || 0}
            </p>
          </div>
          <div className="p-3 bg-blue-50 rounded-lg">
            <Package className="text-[#5050EA]" size={24} />
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-xl shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">{dictionary["buyers"][language]}</p>
            <p className="text-2xl font-bold mt-1">
              {summary?.total_buyers || 0}
            </p>
          </div>
          <div className="p-3 bg-blue-50 rounded-lg">
            <Users className="text-[#5050EA]" size={24} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesStats;
